import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

import { COWTUXPipesModule } from '@cowtux/pipes/pipes.module';

import { COWTUXMaterialColorPickerComponent } from '@cowtux/components/material-color-picker/material-color-picker.component';

@NgModule({
    declarations: [
        COWTUXMaterialColorPickerComponent
    ],
    imports: [
        CommonModule,

        FlexLayoutModule,

        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatTooltipModule,

        COWTUXPipesModule
    ],
    exports: [
        COWTUXMaterialColorPickerComponent
    ],
})
export class COWTUXMaterialColorPickerModule
{
}
